export type ImportedModelLoadGuard = {
  isStale?: () => boolean
}

export class ImportedModelLoadAbortedError extends Error {
  constructor(message = '导入模型加载请求已失效') {
    super(message)
    this.name = 'ImportedModelLoadAbortedError'
  }
}

export function throwIfImportedModelRequestStale(guard?: ImportedModelLoadGuard): void {
  if (guard?.isStale?.()) {
    throw new ImportedModelLoadAbortedError()
  }
}

export function isImportedModelLoadAbortedError(error: unknown): error is ImportedModelLoadAbortedError {
  let currentError: unknown = error
  const visitedErrors = new Set<unknown>()

  // loader/importer 会用 Error.cause 保留阶段和资产上下文；取消语义必须沿 cause 链继续识别，
  // 否则 stale 请求会被 UI 当成普通加载失败并错误弹窗。
  while (currentError instanceof Error && !visitedErrors.has(currentError)) {
    if (currentError instanceof ImportedModelLoadAbortedError) {
      return true
    }
    visitedErrors.add(currentError)
    currentError = currentError.cause
  }
  return false
}
